<app-page-shell [title]="'settings_title' | translate" [description]="'settings_desc' | translate">
  <div class="flex flex-col gap-6">
    <!-- TabBar -->
    <div class="mb-4">
      <app-tabs [items]="(tabs$ | async) ?? []" [activeValue]="activeTab" (activeValueChange)="setActiveTab($event)">
      </app-tabs>
    </div>

    <!-- Tab Content Container -->
    <div class="bg-white rounded-3xl p-8 shadow-sm border border-slate-100 min-h-[600px]">

      <!-- Profile Tab -->
      <app-profile-tab *ngIf="activeTab === 'profile'"></app-profile-tab>

      <!-- Subscriptions Tab -->
      <app-subscriptions-tab *ngIf="activeTab === 'subscriptions'"
        (navigateToTab)="setActiveTab($event)"></app-subscriptions-tab>

      <!-- Executables Tab -->
      <app-executables-tab *ngIf="activeTab === 'executables'"></app-executables-tab>

      <!-- Imaging (RX) Tab -->
      <app-imaging-tab *ngIf="activeTab === 'imaging'"></app-imaging-tab>

      <!-- Clinic Tab -->
      <app-clinic-tab *ngIf="activeTab === 'clinic'"></app-clinic-tab>

      <!-- Billing Tab -->
      <app-billing-tab *ngIf="activeTab === 'billing'"></app-billing-tab>

      <app-patient-fields-tab *ngIf="activeTab === 'patient_fields'"></app-patient-fields-tab>

      <!-- Novigest Tab -->
      <app-novigest-tab *ngIf="activeTab === 'novigest'"></app-novigest-tab>

      <!-- Agenda Tab -->
      <!-- Agenda Tab -->
      <app-agenda-tab *ngIf="activeTab === 'agenda'"></app-agenda-tab>

      <!-- Access Profiles Tab -->
      <!-- Access Profiles Tab -->
      <app-access-profiles-tab *ngIf="activeTab === 'access_profiles'"></app-access-profiles-tab>

      <!-- Users Tab -->
      <app-users-tab *ngIf="activeTab === 'users'"
        (navigateToProfiles)="setActiveTab('access_profiles')"></app-users-tab>

      <!-- Diagnostics & Treatments Tab -->
      <app-diagnostic-treatment-tab *ngIf="activeTab === 'diagnostics_treatments'"></app-diagnostic-treatment-tab>

      <!-- Speciality Tab -->
      <app-speciality-tab *ngIf="activeTab === 'specialty'"></app-speciality-tab>

      <!-- Online Booking Tab (gated by clinic_subscriptions status) -->
      <app-booking-settings-tab *ngIf="activeTab === 'online_booking'"></app-booking-settings-tab>

      <!-- Audit Logs Tab (superadmin) -->
      <app-audit-logs *ngIf="activeTab === 'audit_logs'" [embedded]="true"></app-audit-logs>

      <!-- Security Tab -->
      <!-- <app-security-tab *ngIf="activeTab === 'security'"></app-security-tab> -->

      <!-- Placeholder for other tabs -->
      <div
        *ngIf="activeTab !== 'profile' && activeTab !== 'subscriptions' && activeTab !== 'executables' && activeTab !== 'imaging' && activeTab !== 'clinic' && activeTab !== 'billing' && activeTab !== 'patient_fields' && activeTab !== 'novigest' && activeTab !== 'agenda' && activeTab !== 'access_profiles' && activeTab !== 'users' && activeTab !== 'diagnostics_treatments' && activeTab !== 'specialty' && activeTab !== 'online_booking' && activeTab !== 'audit_logs' && activeTab !== 'security'"
        class="animate-fadeIn py-20 flex flex-col items-center justify-center text-slate-400">
        <p class="text-[10px] font-black uppercase tracking-[0.2em]">{{ activeTab | uppercase }} - {{ 'module_in_development' | translate }}
        </p>
      </div>
    </div>
  </div>
</app-page-shell>